"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxContainer = exports.TextFieldContainer = exports.GuideContainer = exports.ControlsContainer = exports.FormBodyContainer = exports.Description = exports.ErrorContainer = exports.LoadingSpinnerContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.LoadingSpinnerContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;
exports.ErrorContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 2rem;

  i {
    color: ${config_1.colors.redError};
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  p {
    font-family: ${config_1.fontFamilies.primary};
    line-height: 1.5rem;
    text-align: center;
  }
`;
exports.Description = styled_components_1.default.p `
  color: ${config_1.colors.thundercloud};
  line-height: 1.3rem;
  margin-bottom: 1rem;
`;
exports.FormBodyContainer = styled_components_1.default.div `
  border-bottom: 1px solid ${config_1.colors.huron};
  border-top: 1px solid ${config_1.colors.huron};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 38.75rem;
  padding: 1rem;
`;
exports.ControlsContainer = styled_components_1.default.div `
  margin: 1rem;
`;
exports.GuideContainer = styled_components_1.default.div `
  border-top: 1px solid ${config_1.colors.huron};
  height: 5.625rem;
  padding: 1rem;
`;
exports.TextFieldContainer = styled_components_1.default.div `
  margin-top: 0.5rem;
`;
exports.CheckBoxContainer = styled_components_1.default.div `
  display: flex;
  height: 4.3rem;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 0.5rem;
`;
